const iconsName = {
  HOSPITALISATION: 'HOSPITALISATION',
  'SOINS COURANTS': 'SOINS_COURANTS',
  'AIDES AUDITIVES': 'AIDE_AUDITIVE',
  DENTAIRE: 'DENTAIRE',
  OPTIQUE: 'OPTIQUE',
  'MATERNITÉ, PRÉVENTION ET AUTRES SOINS': 'maternity'
};
export const getGarantyIcon = (code) => {
  return iconsName[code];
};
